import React from "react";
import { Link } from "react-router-dom";
import { Trophy, Loader2, User } from "lucide-react";

/**
 * Phase 25b · Horizontal carousel of top human creators (30d, virtual excluded).
 */
export function MarketplaceTopCreatorsCarousel({ items = [], loading }) {
  return (
    <section data-testid="mp-top-creators-carousel" className="space-y-3">
      <header>
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-text-secondary mb-1">
          <Trophy className="h-3 w-3 text-neutral-400" /> Top creators — Last 30 days
        </div>
        <h2 className="text-lg font-semibold tracking-tight text-[var(--color-text-main)]">
          Community leaderboard
        </h2>
      </header>
      {loading ? (
        <div className="flex items-center gap-2 text-xs text-text-secondary py-6">
          <Loader2 className="h-3 w-3 animate-spin" /> Loading creators…
        </div>
      ) : items.length === 0 ? (
        <div className="rounded-2xl border border-[var(--color-border)] bg-[var(--color-card)] p-8 text-center text-xs text-text-secondary">
          Nessun creator umano ha ancora venduto nell'ultimo mese.
        </div>
      ) : (
        <div className="grid grid-flow-col auto-cols-[minmax(210px,1fr)] gap-3 overflow-x-auto pb-3 snap-x snap-mandatory">
          {items.slice(0, 10).map((c, idx) => (
            <Link
              key={c.creator_id}
              to={`/creator/${c.creator_id}/store`}
              data-testid={`mp-top-creator-card-${c.creator_id}`}
              className="group snap-start rounded-2xl border border-[var(--color-border)] bg-[var(--color-card)] p-4 hover:border-neutral-400/60 transition-colors block"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="h-12 w-12 rounded-full bg-gradient-to-br from-neutral-400/30 to-neutral-400/30 flex items-center justify-center border border-neutral-400/40 shrink-0">
                  <User className="h-6 w-6 text-neutral-300" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="text-xs text-text-secondary">
                    #{idx + 1} <span className="text-neutral-300">·</span> Creator
                  </div>
                  <h3 className="text-sm font-semibold text-[var(--color-text-main)] line-clamp-1 group-hover:text-neutral-300 transition-colors">
                    {c.name || c.creator_id?.slice(0, 12)}
                  </h3>
                </div>
              </div>
              <div className="flex items-center justify-between text-[10px] uppercase tracking-widest text-text-secondary">
                <span className="tabular-nums">{c.sales_count || 0} sales</span>
                <span className="text-neutral-300 group-hover:underline">Visit store →</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}

export default MarketplaceTopCreatorsCarousel;
